import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { ENC } from "@/constants/testIds";
import { formatDate } from "@/lib/patientChart";
import { versionKindLabel } from "@/lib/noteApi";

export default function NoteHistoryDialog({ open, onOpenChange, note, versions = [] }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid={ENC.screenNoteHistoryDialog} className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>Version history</DialogTitle>
          <DialogDescription>
            {note?.noteType?.displayName || "Note"}
            {note?.title ? ` — ${note.title}` : ""}. Versions belong to this Note.
          </DialogDescription>
        </DialogHeader>
        <ol className="space-y-2">
          {versions.map((version) => (
            <li
              key={version.id}
              data-testid={`${ENC.screenNoteHistoryRow}-${version.id}`}
              className="rounded-lg border border-slate-200 px-3 py-2 text-sm"
            >
              <div className="flex items-center justify-between gap-2">
                <span className="font-semibold text-slate-900">
                  V{version.versionNumber} · {versionKindLabel(version.kind)}
                </span>
                <span className="text-xs font-semibold uppercase text-slate-500">{version.status}</span>
              </div>
              <p className="mt-1 text-xs text-slate-500">
                {version.signedAt
                  ? `Signed ${formatDate(version.signedAt, "MMM d, yyyy h:mm a")}`
                  : version.createdAt
                    ? `Created ${formatDate(version.createdAt, "MMM d, yyyy h:mm a")}`
                    : "—"}
                {version.authorId ? ` · Author ${String(version.authorId).slice(0, 8)}` : ""}
              </p>
            </li>
          ))}
          {!versions.length ? <p className="text-sm text-slate-500">No versions yet.</p> : null}
        </ol>
      </DialogContent>
    </Dialog>
  );
}
